<template lang="pug">
 
  v-data-table( v-model="Datos.registro" :headers='headers' :items='registro' item-key='id' :footer-props="footerProps" sort-desc sort-by='numero_de_operacion')
    template(v-slot:item.creado_el='{ item }')
      span {{item.creado_el | imprimir_fecha }}
    template(v-slot:item.action='{ item }')
      v-row
        Aprobar_button( v-if='es_administrador' :id='item.id' tipo='orden_de_compra' :aprobado='item.aprobado')
        orden_de_compra_imprimir( v-if='!es_administrador && item.aprobado' :llave= 'item.id' )
        agregar_comprobante_de_pago( v-if='!es_administrador  && item.aprobado' :llave='item.id' :estado='item.estado_del_documento == "comprobante generado" || item.estado_del_documento == "procesando"')
        Notificar_por_whatsapp_button( v-if='!es_administrador  && item.aprobado' :id='item.id' texto='Buen día, en esta oportunidad notificamos una orden de compra. Puede consultarla en el siguiente vínculo:')
                
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
    data: () => ({
      headers: [
        { text: 'Nº',  value: 'numero_de_orden_de_compra' },
        { text: 'Nº',  value: 'numero_de_cotizacion' },

        { text: 'Creado por', value:'creado_por' },
        { text: 'Frecha de creación', value:'creado_el' },
        { text: 'Acciones', value: 'action'}
      ],
      footerProps: {
        'items-per-page-options':   [15, 30, 50]
      },
    }),
    methods:{
      ver_propuestas (idCotizacion) {
        this.encabezados_con_proveedor = [...this.headers]
        this.Proveedores.map(item => this.encabezados_con_proveedor.push({text: item, value: item}))
        this.$store.dispatch('Cotizaciones/ver_propuestas', idCotizacion)
      },
    },
    computed:{
      ...mapGetters({
        registro: 'Ordenes_de_compra/registro',
      }),
      ...mapState({
        Datos: state=> state.Ordenes_de_compra.datos,
        Ordenes_de_compra : state =>state.Ordenes_de_compra,
      })
    },
    components:{
      orden_de_compra_imprimir: ()=>import('.././componentes/orden_de_compra_imprimir'),
      agregar_comprobante_de_pago: ()=> import('./agregar_comprobante_de_pago'),
      Aprobar_button: () => import('./aprobar_button'),
      Notificar_por_whatsapp_button: ()=>import('./notificar_por_whatsapp_button')
    },
    props: {
      es_administrador: Boolean
    }
}
</script>
